import { MaterialMacro } from 'models/material-macro';

// Matches the separator and empty fallback used for the Group column, so the two
// link-type columns read the same way.
export const formatMaterialMacroNames = (materialMacros: MaterialMacro[] = []): string => {
    const names = materialMacros.map((materialMacro) => materialMacro.name).filter(Boolean);
    return names.length ? names.join(' | ') : '-';
};
